import {
  createSlice,
  createAsyncThunk,
  createSelector } from
'@reduxjs/toolkit';
import { ApolloClient, gql, NormalizedCacheObject } from '@apollo/client';
import { RootState } from '@src/redux/store';
import * as TYPES from '@src/redux/types';

const GRAPHQL = gql`
  mutation setKitSubscription(
    $id: String
    $data: createKitSubscriptionInput
  ) {
    setKitSubscription(id: $id, data: $data) {
      id
      status
      error {
        message
        statusCode
      }
    }
  }
`;

const EMAIL_RE = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

const initialState: TYPES.MutationResponseState = {
  result: null,
  error: null,
  loading: false
};

export const setKitSubscriptionRequest = createAsyncThunk<
  TYPES.MutationResponse,
  {id?: String;data?: TYPES.CreateKitSubscriptionInput;},
  {extra: ApolloClient<NormalizedCacheObject>;}>(

  'kit/set_kit_subscription',
  async (
  params: {id?: String;data?: TYPES.CreateKitSubscriptionInput;},
  { extra: client }) =>
  {
    try {
      const response = await client.mutate({
        mutation: GRAPHQL,
        variables: params
      });
      return response.data.setKitSubscription;
    } catch (error) {
      const err = error as {message?: String;statusCode?: String;};
      return Promise.reject({
        message: err.message || 'An error occurred',
        statusCode: err.statusCode || '500'
      });
    }
  }
);

const setKitSubscriptionSlice = createSlice({
  name: 'set_kit_subscription',
  initialState: initialState,
  reducers: {
    setKitSubscriptionClear: (state) => {
      state.result = null;
      state.error = null;
      state.loading = false;
    }
  },
  extraReducers: (builder) => {
    builder.
    addCase(setKitSubscriptionRequest.pending, (state) => {
      state.result = null;
      state.error = null;
      state.loading = true;
    }).
    addCase(setKitSubscriptionRequest.fulfilled, (state, action) => {
      state.result = action.payload;
      state.loading = false;
    }).
    addCase(setKitSubscriptionRequest.rejected, (state, action) => {
      state.error = action.payload as Error || {
        message: 'Failed to fetch',
        statusCode: '500'
      };
      state.loading = false;
    });
  }
});

export const { setKitSubscriptionClear } =
setKitSubscriptionSlice.actions;

export const setKitSubscription = createSelector(
  (state: RootState) => state.kit.setKitSubscription.result,
  (state: RootState) => state.kit.setKitSubscription.error,
  (state: RootState) => state.kit.setKitSubscription.loading,
  (result, error, loading) => ({
    result,
    error,
    loading
  })
);

export default setKitSubscriptionSlice.reducer;